import {
  StepConnector as MuiStepConnector,
  stepConnectorClasses,
  styled,
} from '@mui/material';

export const StepConnector = styled(MuiStepConnector)(() => ({
  [`&.${stepConnectorClasses.vertical}`]: {
    marginLeft: 16.5,
    [`& .${stepConnectorClasses.lineVertical}`]: {
      borderLeft: '1.6px solid grey',
    },
  },
}));
